export default function setupElementAnimation( element, visible, isPrev ) {
	// Skip if animation end event not supported
	if ( ! element || typeof element.onanimationend === 'undefined' ) {
		return;
	}

	const animationClass = `animating-${ visible ? 'in' : 'out' }`;
	const directionClass = `${ animationClass }--${ isPrev ? 'prev' : 'next' }`;

	// Add classes to dictate animation, remove when complete
	element.classList.add( animationClass, directionClass );
	element.addEventListener( 'animationend', () => {
		element.classList.remove( animationClass, directionClass );
	}, { once: true } );
}
